import CustomFetch from '../components/CustomFetch';
import IP from '../common/IP';
import storageService from './StorageService';
import StorageService from './StorageService';


class AuthService {
  login(username, password, timeOffset, plant) {
    let pcd

    if(plant === 'GR_NJ') {
      pcd = '0003'
    } else {
      pcd = '0003'
    }

    CustomFetch(IP.getIp(), 'api/auth/sign_in', {
      PlantCd: pcd,
      EmpCd: username,
      EmpPw: password
    }).then((res) => {
      console.log(res);
      if (res.code === 1) {

        console.log("로그인 토큰 데이터 : " + JSON.stringify(res));
        storageService.setItem("Plant", plant)
        storageService.setItem("PlantCd", pcd)
        this.setLoginStorage(res, timeOffset);
        window.location.replace("/");
        // window.location.replace("/" + plant);
      }else {
        alert(res.message);
      }
    }).catch((error) => console.log(JSON.stringify(error)));
  }

  checkLogin() {
    return sessionStorage.getItem("user") !== null;
  }

  logout() {
    sessionStorage.removeItem("user");
    sessionStorage.removeItem("end-time");
    sessionStorage.removeItem("start-time");
  }

  // 사용자의 전체 정보를 가져온다.
  getUser() {
    const item = sessionStorage.getItem("user");
    return JSON.parse(item);
  }

  getUserCode() {
    return this.getUser().EmpCd;
  }

  getBpCd() {
    return this.getUser().BpCd;
  }

  getPlantCd() {
    return StorageService.getItem("PlantCd");
  }

  getMaker() {
    return 'SY'.includes(this.getEmpGroup()) ? '%' : this.getBpCd();
  }

  getUserName() {
    return this.getUser().EmpNm;
  }

  getBpGroup() {
    return this.getUser().BpGroup;
  }

  getEmpGroup() {
    return this.getUser().EmpGr;
  }

  setLoginStorage(res, timeOffset) {
    sessionStorage.setItem("user", JSON.stringify(res.data));
    sessionStorage.setItem("start-time", -1);
    sessionStorage.setItem("end-time", timeOffset);
  }
}
export default new AuthService();